module.exports = __webpack_public_path__ + "static/media/verhaltensbasiert_step_7.3812a780.png";